import React, { useContext } from 'react';
import styled from 'styled-components';
import theme from '@fortress-technology-solutions/fortress-component-library/theme';
import { pathOr } from 'ramda.pathor/pathOr';

import { AppContext } from 'contexts/AppContext';
import { EL_LOGO_URL } from 'utils/constants';

const StyledLogo = styled.div`
  background-image: url(${(p) =>
    p.background ? `"${p.background}"` : `"${EL_LOGO_URL}"`});
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: contain;
  margin-bottom: ${(p) => (p.padBottom ? '30px' : '0')};
  max-height: calc(100% - 24px);

  @media (max-width: ${theme.breakpoints.values.sm}px) {
    margin-bottom: ${(p) => (p.padBottom ? '16px' : '0')};
  }
`;

const Logo = (props) => {
  const { marketingInfo } = useContext(AppContext);
  const logoImageUrl = pathOr('', ['propertyLogoLink'], marketingInfo);
  return <StyledLogo background={logoImageUrl} {...props} />;
};

export default Logo;
